import React, { useEffect } from "react";
import { PageLayout, InitialOfferSkeletonLoader } from "../../components";
import { InitialOfferHelmet } from "../../components/SellHelmets";
import { useDispatch, useSelector } from "react-redux";
import {
  getSourceSystemContent,
  selectAppraisal
} from "../../store/selectors";
import { useRetryRequest } from "../../hooks/useRetryRequest";
import { appraisalSlice } from "../../store/slices/Appraisal";
import { useSourceSystem } from "../../hooks/useSourceSystem";
import { useInitialOffer } from "../InitialOffer/useInitialOffer";
import EstimatedOfferPartExchange from "../EstimatedOfferPartExchange/EstimatedOfferPartExchange";
import { ValuationAccuracy } from "../../helpers/valuationAccuracy";

export default function EstimatedOfferContainer() {
  const {
    loading,
    data: { appraisalSessionId },
    answersChanged
  } = useSelector(selectAppraisal);
  const { initialOfferContent } = useSelector(getSourceSystemContent);

  const { valuationRequest, submitCompleteAppraisal, showSpinner } =
    useRetryRequest();
  const dispatch = useDispatch();

  const requestValuationWithRetry = () => {
    if (appraisalSessionId && answersChanged) {
      valuationRequest(ValuationAccuracy.FULL_VALUATION);
      dispatch(appraisalSlice.actions.setAnswersChanged(false));
      dispatch(appraisalSlice.actions.setIsFullValuation(true));
    }
  };
  useEffect(requestValuationWithRetry, []);

  const {
    sourceSystem: { getStepperPercentageValue }
  } = useSourceSystem();
  const percentageStep =
    getStepperPercentageValue && getStepperPercentageValue();

  const { handleSubmit, showEstimatedOfferPartExchange } = useInitialOffer();

  if (loading) {
    return (
      <PageLayout>
        <InitialOfferHelmet />
        <PageLayout.Header
          title="Your valuation"
          percentageValue={percentageStep}
          step={initialOfferContent?.stepNumber}
        />
        <PageLayout.Content>
          <InitialOfferSkeletonLoader />
        </PageLayout.Content>
      </PageLayout>
    );
  }

  return (
    <>
      {!loading && initialOfferContent.stepNumber && (
        <EstimatedOfferPartExchange
          onSubmit={
            showEstimatedOfferPartExchange
              ? handleSubmit
              : submitCompleteAppraisal
          }
          showSpinner={showSpinner}
          percentageValue={
            !showEstimatedOfferPartExchange ? percentageStep : null
          }
        />
      )}
    </>
  );
}
